import { NavItem } from "react-bootstrap";

const NavigationBarSeparator = () => {
  return (
    <NavItem className="mx-2 border-end d-none d-xl-block">&nbsp;</NavItem>
  );
};

export default NavigationBarSeparator;
